<template>
  <div id="AgencyLevel">
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on }">
        <v-btn rounded color="primary" v-on="on" @click="getOffice()" dark>Update Agency</v-btn>
      </template>
      <v-card>
        <v-form ref="form" lazy-validation>
          <v-text-field v-model="office.agency" label="Agency Code" disabled required></v-text-field>
          <v-text-field v-model="office.officeName" label="Office Name" required></v-text-field>
          <v-btn text @click="menu = false" >Cancel</v-btn>
          <v-btn color="primary" text @click="menu = false">Save</v-btn>
        </v-form>
      </v-card>
    </v-menu>

    <v-menu v-model="assignUser" :close-on-content-click="false" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on }">
        <v-btn rounded color="primary" v-on="on" small dark>Assign Users to Agency</v-btn>
      </template>
      <v-card>
        <v-form ref="form" lazy-validation>
          <v-text-field v-model="userName" label="User Name" required></v-text-field>
          <v-text-field v-model="email" label="E-mail" required></v-text-field>
          <v-btn text @click="assignUser = false">Cancel</v-btn>
          <v-btn color="primary" text @click="assignUser = false">Save</v-btn>
        </v-form>
      </v-card>
    </v-menu>

    <v-menu v-model="createProgram" :close-on-content-click="false" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on }">
        <v-btn rounded color="primary" v-on="on" small dark>Create Program</v-btn>
      </template>
      <v-card>
        <v-form ref="form" lazy-validation>
          <v-text-field v-model="agency" label="Agency Code" required></v-text-field>
          <v-text-field v-model="program" label="Program Code" required></v-text-field>
          <v-text-field v-model="description" label="Description" required></v-text-field>
          <v-btn text @click="createProgram = false">Cancel</v-btn>
          <v-btn color="primary" text @click="createProgram = false">Save</v-btn>
        </v-form>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import Vue from "vue";
import { officeManagementService } from '../../services/officeManagementService';
export default {
  name: "AgencyLevel",
  props: {
    officeId: Number
  },
  components: {},
  data: () => ({
    agency: "",
    program: "001",
    description: "",
    createProgram: false,
    assignUser: false,
    userName: "",
    email: "",
    menu: false,
    office: {}
  }),
  methods: {
    onUpdateAnswer: function (val) {
      this.$emit("menu", val);
    },
    reset () {
      this.$refs.form.reset();
    },
    getOffice () {
      const me = this;
      const o = officeManagementService
          .getOfficeById(this.$props.officeId)
          .then(function (response) {
          if (response && response.data) {
            me.office = response.data;
          }
        })
        .catch(function (e) {
          console.error(e);
          throw e;
        });
    }
  }
};
</script>
